import axios from './axios';

export default {
  create(testId, answerIds, writtenAnswers) {
    return axios.post(`/tests/${testId}/student_tests`, { student_test: { answer_ids: answerIds, student_test_written_answers_attributes: writtenAnswers } });
  },
  update(studentTestId, answerIds, writtenAnswers) {
    return axios.put(`/student_tests/${studentTestId}`, { student_test: { answer_ids: answerIds, student_test_written_answers_attributes: writtenAnswers } });
  },
  finish(testId) {
    return axios.post(`tests/${testId}/student_tests/finish`);
  },
};
